import React from "react";

const Footer = () => {
  return (
    <div
      className="footer pt-0 pt-md-5 pb-md-5 pb-0"
      style={{ overflow: "hidden" }}
    >
      <div className="container pt-5 pb-5">
        <div className="row">
          <div
            className="col-lg-5"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
                     <img src="/assets/images/logo.png" alt="" />


            {/* <p>Get weekly news on blockchain.</p>
            <div className="d-flex align-items-center flex-wrap flex-md-nowrap gap-3 mt-4 mb-3">
              <div className="input-groups">
                <svg
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.2">
                    <path
                      d="M15.8332 3.83325H4.1665C3.50346 3.83325 2.86758 4.09664 2.39874 4.56549C1.9299 5.03433 1.6665 5.67021 1.6665 6.33325V14.6666C1.6665 15.3296 1.9299 15.9655 2.39874 16.4344C2.86758 16.9032 3.50346 17.1666 4.1665 17.1666H15.8332C16.4962 17.1666 17.1321 16.9032 17.6009 16.4344C18.0698 15.9655 18.3332 15.3296 18.3332 14.6666V6.33325C18.3332 5.67021 18.0698 5.03433 17.6009 4.56549C17.1321 4.09664 16.4962 3.83325 15.8332 3.83325V3.83325ZM15.4915 5.49992L10.5915 10.3999C10.514 10.478 10.4219 10.54 10.3203 10.5823C10.2188 10.6246 10.1098 10.6464 9.99984 10.6464C9.88983 10.6464 9.78091 10.6246 9.67936 10.5823C9.57781 10.54 9.48564 10.478 9.40817 10.3999L4.50817 5.49992H15.4915ZM16.6665 14.6666C16.6665 14.8876 16.5787 15.0996 16.4224 15.2558C16.2661 15.4121 16.0542 15.4999 15.8332 15.4999H4.1665C3.94549 15.4999 3.73353 15.4121 3.57725 15.2558C3.42097 15.0996 3.33317 14.8876 3.33317 14.6666V6.67492L8.23317 11.5749C8.70192 12.0431 9.33734 12.3061 9.99984 12.3061C10.6623 12.3061 11.2978 12.0431 11.7665 11.5749L16.6665 6.67492V14.6666Z"
                      fill="#F8F8FA"
                    />
                  </g>
                </svg>

                <input type="text" placeholder="Your mail address" />
              </div>
              <button className="bg-btn">Subscribe</button>
            </div> */}
          </div>
          <div className="col-lg-1"></div>
          <div
            className="col-lg-3 "
            data-aos="fade-left"
            data-aos-duration="1500"
          >
            <ul>
              <li>
                <a href="#about">Features</a>
              </li>
              <li>
                <a href="#contact">Solutions</a>
              </li>
              <li>
                <a href="#blog">Use Cases</a>{" "}
              </li>
              <li>
                <a href="#blog">Insights</a>{" "}
              </li>
            </ul>
          </div>
          <div
            className="col-lg-3 "
            data-aos="fade-left"
            data-aos-duration="1500"
          >
            <ul>
              <li>
                <a href="#join">Company</a>
              </li>
              <li>
                <a href="#join">Policies</a>
              </li>
              <li>
                <a href="#join">Conditions</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-lg-12">
            <div
              className="Line2 mb-3"
              style={{
                width: "100%",
                height: 0,
                opacity: 0.1,
                border: "1px white solid",
              }}
            ></div>
            <div className="d-flex align-items-center      gap-4">
              <p>Connect with</p>

              <div className="d-flex align-items-center      gap-4">
                <a href="#">
                  <img src="/assets/images/Facebook.svg" alt="instagram" />
                </a>
                <a href="#">
                  <img src="/assets/images/Twitter (1).svg" alt="twitter" />
                </a>
                <a href="#">
                  <img src="/assets/images/Instagram (1).svg" alt="Facebook" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
